import { Schema, TeamStat, Stat } from './index.d';

const getPercentage = value => {
  if (value == null) return null;

  const asNumber = parseFloat(value);

  if (asNumber < 0) {
    return Math.trunc(asNumber * 100);
  }

  return Math.trunc(asNumber);
};

const calculatePercentage = (first, second) => {
  const firstVal = parseFloat(first);
  const secondVal = parseFloat(second);

  if (firstVal === secondVal) return 50;

  const total = firstVal + secondVal;

  return Math.round(firstVal / total * 100);
};

const getTeamStats = (stat, teams) => {
  const { home, away } = teams;

  if (typeof stat.format === 'function') {
    const homeArgs = Array.isArray(stat.key) ? stat.key.map(key => home[key]) : home[stat.key];
    const awayArgs = Array.isArray(stat.key) ? stat.key.map(key => away[key]) : away[stat.key];

    const homeStatValue = stat.format(...homeArgs);
    const awayStatValue = stat.format(...awayArgs);

    return {
      home: {
        value: homeStatValue,
        meta: home[stat.meta_key] || null,
        percentage:
          getPercentage(home[stat.percentage]) || calculatePercentage(homeStatValue, awayStatValue),
      },
      away: {
        value: awayStatValue,
        meta: away[stat.meta_key] || null,
        percentage:
          getPercentage(away[stat.percentage]) || calculatePercentage(awayStatValue, homeStatValue),
      },
    };
  }

  return {
    home: {
      value: home[stat.key],
      meta: home[stat.meta_key] || null,
      percentage:
        getPercentage(home[stat.percentage]) || calculatePercentage(home[stat.key], away[stat.key]),
    },
    away: {
      value: away[stat.key],
      meta: away[stat.meta_key] || null,
      percentage:
        getPercentage(away[stat.percentage]) || calculatePercentage(away[stat.key], home[stat.key]),
    },
  };
};

export default (teams: Stat, schema: Schema[]): TeamStat[] => {
  if (!teams || !teams.home || !teams.away || !schema) return [];

  return schema.map(stat => {
    const teamStats = getTeamStats(stat, teams);

    return {
      name: stat.label,
      isNegative: stat.isNegative,
      localized_name: stat.localized_label,
      ...teamStats,
    };
  });
};
